import '../Styles/ContactPage.css';
import Copy from '../Img/copy.svg'

function ContactPage(props) {

    function copyEmail() {
        navigator.clipboard.writeText("1aguilarmatias@gmail.com")
        .then(
            Alert()
        )
    }
    function copyPhone() {
        navigator.clipboard.writeText("+54 9 223 682-9690")
        .then(
            Alert()
        )
    }

    function Alert() {
        if (
            document.getElementById('ContactPage__copied') &&
            document.getElementById('ContactPage__copiedImg') &&
            document.getElementById('ContactPage__copiedP')
        ) {
            document.getElementById('ContactPage__copied').style.backgroundColor = "#2d3034";
            document.getElementById('ContactPage__copiedImg').style.transform = "scale(1)";
            document.getElementById('ContactPage__copiedP').style.color = "#ccd6f6";

            setTimeout(() => {
                document.getElementById('ContactPage__copied').style.backgroundColor = "#2d303400";
                document.getElementById('ContactPage__copiedImg').style.transform = "scale(0)";
                document.getElementById('ContactPage__copiedP').style.color = "#ccd6f600";
            }, "5000")
        }
    }

    return (
        <div className="ContactPage" data-aos='fade-zoom-in' data-aos-duration='1500' data-aos-delay="200">
            <div className="ContactPage__container">
                <form className='ContactPage__form' action="https://formspree.io/f/xnqrojgg" method="POST">
                    <label>
                        E-Mail:
                        <input className='ContactPage__formInput' type="email" name="email" />
                    </label>
                    <label>
                        {props.language === props.uk ? "Your message:" : "Deje su mensaje"}
                        <textarea className='ContactPage__formInput' name="message"></textarea>
                    </label>
                    <button type="submit">{props.language === props.uk ? "Send" : "Enviar"}</button>
                </form>
                <div className="ContactPage__other">
                    <h3>{props.language === props.uk ? "Other ways..." : "Formas alternativas:"}</h3>
                    <p>1aguilarmatias@gmail.com</p>
                    <img src={Copy} onClick={copyEmail} alt="" />
                    <p>+54 9 223 682-9690</p>
                    <img src={Copy} onClick={copyPhone} alt="" />
                </div>
            </div>
            <div className="ContactPage__copied" id='ContactPage__copied'>
                <div>
                    <img src={Copy} alt="" id='ContactPage__copiedImg' />
                    <p id='ContactPage__copiedP'>{props.language === props.uk ? "Successfully copied" : "Copiado con exito"}</p>
                </div>
            </div>
        </div>
    )
}
export default ContactPage